import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, onUnmounted, nextTick } from "vue";
import { trans } from "laravel-vue-i18n";
import { MembershipData } from "@/ts/components/members";
import { format } from "fecha";
import { Checkbox, Submit } from "@/ts/components/form";
import { useForm } from "vee-validate";
import * as Yup from "yup";
import { nl } from "yup-locales";

interface Props {
    data: MembershipData;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    data: { type: null, required: true }
  },
  emits: ["submit", "back", "mounted"],
  setup(__props: any, { expose, emit }) {
  expose();

const props = __props as {
    data: MembershipData;
}

const component = ref<HTMLDivElement>();




const schema = computed(() =>
    Yup.object({
        privacy: Yup.bool().oneOf([true]),
    }),
);

const { handleSubmit, meta } = useForm({
    initialValues: { privacy: false },
    validationSchema: schema,
});

onMounted(async () => {
    await nextTick();

    const updateHeight = () => {
        if (component.value) {
            const height = component.value.getBoundingClientRect().height;
            emit("mounted", height);
        }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(() => {
        updateHeight();
    });

    if (component.value) {
        resizeObserver.observe(component.value);
    }

    window.addEventListener("resize", updateHeight);
    window.addEventListener("orientationchange", updateHeight);

    // Clean up
    onUnmounted(() => {
        if (component.value) {
            resizeObserver.unobserve(component.value);
        }
        window.removeEventListener("resize", updateHeight);
        window.removeEventListener("orientationchange", updateHeight);
    });

    // scroll to top
    window.scrollTo(0, 0);
});

const durationString = computed(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const day = today.getDate();
    const endDate = new Date(year + props.data.period!, month, day);
    return `${format(today, "D MMM YYYY")} tot ${format(endDate, "D MMM YYYY")}`;
});

const __returned__ = { component, props, emit, schema, handleSubmit, meta, durationString, trans, Checkbox, Submit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})